export const copyDocumentWithTransform = (source, schemaRef, transform = (_) => _) => source;
